/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { __decorate } from "tslib";
import { html, css, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { isHighchartsMessagePart, isMarkdownMessagePart, isTextMessagePart, } from '../../model.js';
/**
 * WebComponent.
 */
let PwcMessagePart = class PwcMessagePart extends LitElement {
    /**
     * Set programatically the messagePart.
     */
    setMessagePart(messagePart) {
        this.messagePart = messagePart;
    }
    /**
     * @inheritdoc
     */
    render() {
        // guard.
        if (!this.messagePart) {
            return html ``;
        }
        // call the custom renderer.
        // eslint-disable-next-line no-undef
        const customDomElement = prosAiChatUi.render(this.messagePart.kind, this.messagePart.data);
        // render a custom message part.
        if (customDomElement) {
            return html `${customDomElement}`;
        }
        // render a markdown message part.
        if (isMarkdownMessagePart(this.messagePart)) {
            return html `<pwc-markdown
        .messagePart=${this.messagePart}
      ></pwc-markdown>`;
        }
        // render a text message part.
        if (isTextMessagePart(this.messagePart)) {
            return html `<span>${this.messagePart.data}</span>`;
        }
        // render a highcharts message part.
        if (isHighchartsMessagePart(this.messagePart)) {
            return html `<pwc-highcharts
        .data=${this.messagePart.data}
      ></pwc-highcharts>`;
        }
        // no renderer found.
        return html ``;
    }
    /**
     * Get copy content.
     */
    getCopyContent() {
        // init data.
        const result = {
            plainText: '',
            htmlText: '',
        };
        // guard.
        if (!this.messagePart) {
            return result;
        }
        // copy the markdown message part.
        if (isMarkdownMessagePart(this.messagePart)) {
            if (this._pwcMarkdownElement) {
                return this._pwcMarkdownElement.getCopyContent();
            }
        }
        // copy the text message part.
        if (isTextMessagePart(this.messagePart)) {
            result.plainText = this.messagePart.data;
            result.htmlText = this.messagePart.data;
        }
        return result;
    }
};
// styles.
PwcMessagePart.styles = css `
    :host {
      display: flex;
      max-width: 100%;
    }
  `;
__decorate([
    property({ attribute: false, type: Object })
], PwcMessagePart.prototype, "messagePart", void 0);
__decorate([
    query('pwc-markdown', false)
], PwcMessagePart.prototype, "_pwcMarkdownElement", void 0);
PwcMessagePart = __decorate([
    customElement('pwc-message-part')
], PwcMessagePart);
export { PwcMessagePart };
//# sourceMappingURL=pwc-message-part.js.map